import getColor from '~/lib/getColor'

export const PLACEMENT = 'admin-user-profile'
export const BORDER = `1px solid ${getColor('blackAlpha15')}`

export const WARNING_DELETE_ACCOUNT_TITLE =
    'Are you sure you want to delete this user’s account?'
export const DELETE_ACCOUNT_BUTTON_TEXT = 'Delete account'

export const DEFAULT_DISABLE_2FA_ERROR_MESSAGE = 'Failed to disable 2FA'
export const ANOTHER_ADMIN_ONLY_TOOLTIP_TITLE =
    'This action can only be done by another admin'
export const OWN_ACCOUNT_PAGE_ONLY_TOOLTIP_TITLE =
    'This action can only be done from your account'
export const BUSINESS_ACCOUNT_ADMIN_ONLY_TOOLTIP_TITLE =
    'This action is limited to Business Account Admins only.'

export const DELETE_ACCOUNT = 'delete-account'
export const DEACTIVATE_MEMBER = 'deactivate-member'
export const REACTIVATE_MEMBER = 'reactivate-member'

export const FICTIV_EMAIL = 'fictiv.com'

const ID_USER = 'user'
const ID_ADMIN = 'admin'
const ID_PRINTER = 'printer'
const ID_CUSTOMER = 'customer'
const ID_EMPLOYEE = 'employee'
const ID_MP = 'mp'

export const ADMIN = 'admin'
export const MP = 'manufacturing partner'
export const ROLE_IDS = {
    ID_USER,
    ID_ADMIN,
    ID_PRINTER,
    ID_CUSTOMER,
    ID_EMPLOYEE,
    ID_MP,
}

export const NEW_ROLE_IDS = [ID_CUSTOMER, ID_EMPLOYEE, ID_MP, ID_ADMIN]
export const NEW_ROLES = [
    {
        id: ID_CUSTOMER,
        name: 'Customer',
        value: ID_CUSTOMER,
    },
    {
        id: ID_MP,
        name: 'Manufacturing Partner',
        value: ID_MP,
    },
    {
        id: ID_EMPLOYEE,
        name: 'Fictiv Employee',
        value: ID_EMPLOYEE,
    },
    {
        id: ID_PRINTER,
        name: 'Manufacturing Partner (Legacy)',
        value: MP,
    },
    {
        id: ID_ADMIN,
        name: 'Fictiv Admin (Legacy)',
        value: ADMIN,
    },
]

export const PO_ENABLED = 'enterprise'
export const ACTIVITY_SYNC = 'activity_sync'
export const RESELLER = 'reseller'
export const ID_ACTIVITY_SYNC = 'activity_sync'
export const ID_ENTERPRISE = 'enterprise'
export const ID_FEATUREFLAG_API_ACCESS = 'featureflag_api_access'
export const ID_ITAR_VERIFIED = 'itar_verified'
export const ID_PROJECT_ADMIN = 'project_admin'
export const ID_RESELLER = 'reseller'
export const ID_BUSINESS_ADMIN = 'business_admin'
export const ID_OPERATIONS_DRI = 'operations_dri'
export const ID_DFM_MESSAGE_EDITOR = 'dfm_feedback_editor'
export const ID_COSTING_AND_DFM = 'costing_and_dfm'
export const ID_SUPPLIER_QUALITY_ENGINEER = 'supplier_quality_engineer'
export const ID_QUALITY_MANAGER = 'quality_manager'
export const ID_SCHEDULING_ADMIN = 'scheduling_admin'

export const ASSIGN_MP = 'assign_mp'
const ASSIGN_API_CAPABILITY = 'assign_api_capabilities'
const ASSIGN_BUSINESS_ADMIN = 'assign_business_admin'
const ASSIGN_CUSTOMER = 'assign_customer'
const ASSIGN_EMPLOYEE = 'assign_employee'
const ASSIGN_FINANCE_CAPABILITY = 'assign_finance_capabilities'
const ASSIGN_PROJECT_ADMIN = 'assign_project_admin'
const ASSIGN_ITAR_VERIFICATION = 'assign_itar_verification'
const ASSIGN_OPERATIONS_DRI = 'assign_operations_dri'
const ASSIGN_SUPPLIER_QUALITY_ENGINEER = 'assign_supplier_quality_engineer'
const ASSIGN_QUALITY_MANAGER = 'assign_quality_manager'
const ASSIGN_SCHEDULING_ADMIN = 'assign_scheduling_admin'

export const ASSIGN_DFM_MESSAGE_EDITOR = 'assign_dfm_feedback_editor'
export const ASSIGN_COSTING_AND_DFM = 'assign_costing_and_dfm'

export const NEW_CAPABILITIES = [
    {
        id: ID_PROJECT_ADMIN,
        name: 'Project Admin',
        value: ID_PROJECT_ADMIN,
    },
    {
        id: ID_ENTERPRISE,
        name: 'PO enabled',
        value: ID_ENTERPRISE,
    },
    {
        id: ID_RESELLER,
        name: 'Reseller (Tax-exempt)',
        value: ID_RESELLER,
    },
    {
        id: ID_OPERATIONS_DRI,
        name: 'Operations DRI',
        value: ID_OPERATIONS_DRI,
    },
    {
        id: ID_BUSINESS_ADMIN,
        name: 'Business Account Admin',
        value: ID_BUSINESS_ADMIN,
    },
    {
        id: ID_ACTIVITY_SYNC,
        name: 'Activity sync',
        value: ID_ACTIVITY_SYNC,
    },
    {
        id: ID_FEATUREFLAG_API_ACCESS,
        name: 'Feature Flag API Access',
        value: ID_FEATUREFLAG_API_ACCESS,
    },
    {
        id: ID_DFM_MESSAGE_EDITOR,
        name: 'DFM Message Editor',
        value: ID_DFM_MESSAGE_EDITOR,
    },
    {
        id: ID_COSTING_AND_DFM,
        name: 'Costing and DFM',
        value: ID_COSTING_AND_DFM,
    },
    {
        id: ID_SUPPLIER_QUALITY_ENGINEER,
        name: 'Supplier Quality Engineer',
        value: ID_SUPPLIER_QUALITY_ENGINEER,
    },
    {
        id: ID_QUALITY_MANAGER,
        name: 'Quality Manager',
        value: ID_QUALITY_MANAGER,
    },
    {
        id: ID_ITAR_VERIFIED,
        name: 'ITAR Verified',
        value: ID_ITAR_VERIFIED,
    },
    {
        id: ID_SCHEDULING_ADMIN,
        name: 'Scheduling Admin',
        value: ID_SCHEDULING_ADMIN,
    },
    // Do the following need to move to the read only capabilities?
    {
        id: ASSIGN_CUSTOMER,
        name: 'Assign Customer Role',
        value: ASSIGN_CUSTOMER,
    },
    {
        id: ASSIGN_MP,
        name: 'Assign Manufacturing Partner Role',
        value: ASSIGN_MP,
    },
    {
        id: ASSIGN_DFM_MESSAGE_EDITOR,
        name: 'Assign DFM Message Editor',
        value: ASSIGN_DFM_MESSAGE_EDITOR,
    },
    {
        id: ASSIGN_COSTING_AND_DFM,
        name: 'Assign Costing and DFM',
        value: ASSIGN_COSTING_AND_DFM,
    },
]

export type CapabilityType = {
    id: string
    name: string
    value: string
}

export const READ_ONLY_CAPABILITIES: {
    [key: string]: CapabilityType
} = {
    [ASSIGN_PROJECT_ADMIN]: {
        id: ASSIGN_PROJECT_ADMIN,
        name: 'Assign Project Admin',
        value: ASSIGN_PROJECT_ADMIN,
    },
    [ASSIGN_FINANCE_CAPABILITY]: {
        id: ASSIGN_FINANCE_CAPABILITY,
        name: 'Assign Finance Capabilities',
        value: ASSIGN_FINANCE_CAPABILITY,
    },
    [ASSIGN_API_CAPABILITY]: {
        id: ASSIGN_API_CAPABILITY,
        name: 'Assign API Capabilities',
        value: ASSIGN_API_CAPABILITY,
    },
    [ASSIGN_EMPLOYEE]: {
        id: ASSIGN_EMPLOYEE,
        name: 'Assign Employee Role',
        value: ASSIGN_EMPLOYEE,
    },
    [ASSIGN_BUSINESS_ADMIN]: {
        id: ASSIGN_BUSINESS_ADMIN,
        name: 'Assign Business Account Admin Role',
        value: ASSIGN_BUSINESS_ADMIN,
    },
    [ASSIGN_ITAR_VERIFICATION]: {
        id: ASSIGN_ITAR_VERIFICATION,
        name: 'Assign ITAR verification',
        value: ASSIGN_ITAR_VERIFICATION,
    },
    [ASSIGN_SCHEDULING_ADMIN]: {
        id: ASSIGN_SCHEDULING_ADMIN,
        name: 'Assign Scheduling Admin',
        value: ASSIGN_SCHEDULING_ADMIN,
    },
}

export const ADMIN_CAPABILITIES = {
    ASSIGN_API_CAPABILITY,
    ASSIGN_BUSINESS_ADMIN,
    ASSIGN_CUSTOMER,
    ASSIGN_EMPLOYEE,
    ASSIGN_FINANCE_CAPABILITY,
    ASSIGN_ITAR_VERIFICATION,
    ASSIGN_SCHEDULING_ADMIN,
    ASSIGN_MP,
    ASSIGN_PROJECT_ADMIN,
    ASSIGN_OPERATIONS_DRI,
    ASSIGN_DFM_MESSAGE_EDITOR,
    ASSIGN_COSTING_AND_DFM,
    ID_ITAR_VERIFIED,
    ASSIGN_SUPPLIER_QUALITY_ENGINEER,
    ASSIGN_QUALITY_MANAGER,
}
